<template>
  <div id="single-song-player" class="text-center p-5">
    <BRow>
      <BCol cols="2">
        <div class="d-flex flex-column justify-content-center h-100">
          <div class="player-block mb-3">
            <div class="player-block__item">
              <div class="player-block__outer-button player-block__outer-button--nav">
                <BButton @click="toPrevSecond" class="player-block__nav-button">
                  <font-awesome-icon
                      icon="backward"
                      size="xs"
                  />
                </BButton>
              </div>
            </div>
            <div class="player-block__item">
              <div class="player-block__outer-button">
                <BButton @click="togglePlayerStatus" :disabled="currentChapter ? !currentChapter.link : null" class="amplitude-play-pause player-block__play-button player-block__play-button--big">
                  <font-awesome-icon
                      :icon="getPlayerIcon"
                      size="xs"
                  />
                </BButton>
              </div>
            </div>
            <div class="player-block__item">
              <div class="player-block__outer-button">
                <BButton @click.keypress.space="addTimestamp" class="player-block__add-button player-block__play-button--big player-block__play-button--add">
                  <font-awesome-icon
                      icon="bookmark"
                      size="xs"
                  />
                </BButton>
              </div>
            </div>
            <div class="player-block__item">
              <div class="player-block__outer-button player-block__outer-button--nav">
                <BButton @click="toNextSecond" class="player-block__nav-button">
                  <font-awesome-icon
                      icon="forward"
                      size="xs"
                  />
                </BButton>
              </div>
            </div>
          </div>
        </div>
      </BCol>
      <BCol cols="6" class="unique-purple font-weight-bold">
      <div class="d-flex flex-column justify-content-center h-100">
          <BRow class="mb-3">
            <BCol cols="2">
              <span class="amplitude-current-hours"></span>:<span class="amplitude-current-minutes"></span>:<span class="amplitude-current-seconds"></span>
            </BCol>
            <BCol cols="8">
              <progress class="amplitude-song-played-progress w-100 pt-3 pb-3" id="song-played-progress"></progress>
            </BCol>
            <BCol cols="2">
              <span class="amplitude-duration-hours"></span>:<span class="amplitude-duration-minutes"></span>:<span class="amplitude-duration-seconds"></span>
            </BCol>
          </BRow>
      </div>
      </BCol>
      <BCol md="4">
          <button @click="downloadJson" class="btn btn-success btn-sm m-l-20" type="submit" style="font-size: 15px; display: none">
            <i class="mdi mdi-check-circle"></i> Download JSON
          </button>
          <button @click="toAddSync" class="btn btn-success btn-sm m-l-20" type="submit" style="font-size: 15px">
            <i class="mdi mdi-check-circle"></i> Зберегти
          </button>
      </BCol>
    </BRow>
  </div>
</template>

<script>
import Amplitude from 'amplitudejs';
import { eventBus } from "../../../../app";
import {mapActions} from "vuex";
import * as chapterActions from "../../../../store/modules/Chapter/types/actions";

export default {
  name: "AudioPlayer",
  props: {
    chapters: Array,
    currentChapter: Object
  },
  data() {
    return {
      playerStatus: 'playing',
      canBeSaved: false
    };
  },
  computed: {
    getChapters() {
      return this.chapters;
    },
    getPlayerIcon() {
      return this.playerStatus === 'playing' ? 'pause' : 'play';
    }
  },
  methods: {
    ...mapActions('Chapter', {
      addSyncForCurrentChapter: chapterActions.ADD_SYNC_FOR_CURRENT_CHAPTER
    }),
    downloadJson() {
      const data = {
        [this.currentChapter.id]: {
          index: this.currentChapter.index,
          audioBookId: this.currentChapter.audioBookId,
          name: this.currentChapter.name,
          fullName: this.currentChapter.fullName,
          link: this.currentChapter.link,
          text: this.currentChapter.sentences
              ? _.reduce(this.currentChapter.sentences,
                  (prev, sentence) => ({
                    ...prev,
                    [sentence.id]: sentence.sentence
                  }),
                  {})
              : null,
          sync: this.currentChapter.sync
              ? _.reduce(this.currentChapter.sync,
                  (prev, sync) => ({
                    ...prev,
                    [sync.id]: {
                      start: sync.start,
                      finish: sync.finish
                    }
                  }),
                  {})
              : null,
        }
      }
      console.log(data)
      let blob  =  new Blob ([JSON.stringify(data)], { type : "text" } );
      saveAs (blob ,  "config.json" ) ;
    },
    async toAddSync() {
      try {
        await this.addSyncForCurrentChapter({
          id: this.currentChapter.id,
          timestamps: _.values(this.currentChapter.sync)
        })
        if (this.canBeSaved) {
          this.setNotification('success', 'Маркери збережені')
        } else {
          this.setNotification('error', 'Не усi маркери проставленi')
        }
      } catch (err) {
        console.log(err)
      }
    },
    addTimestamp() {
      eventBus.$emit('addTimestamp')
    },
    toNextSecond() {
      const currentAudioIndex = Amplitude.getActiveIndex();
      const currentSecond = Amplitude.getSongPlayedSeconds();
      const nextSecond = currentSecond + 1;
      this.scipToSecond( nextSecond, currentAudioIndex );
    },
    toPrevSecond() {
      const currentAudioIndex = Amplitude.getActiveIndex();
      const currentSecond = Amplitude.getSongPlayedSeconds();
      const prevSecond = currentSecond - 1;
      if(prevSecond >= 0) {
        this.scipToSecond(prevSecond, currentAudioIndex);
      }
    },
    togglePlayerStatus() {
      Amplitude.getPlayerState();
    },
    scipToSecond(second, index) {
      Amplitude.skipTo( second, index );
    },
    setCurrentChapter(chapterId) {
      this.$emit('setCurrentChapter', chapterId);
    },
    setNotification(variant, message) {
      Swal.fire(
          message,
          '',
          variant
      )
    }
  },
  mounted() {
    document.getElementById('song-played-progress').addEventListener('click', function( e ){
      var offset = this.getBoundingClientRect();
      var x = e.pageX - offset.left;

      Amplitude.setSongPlayedPercentage( ( parseFloat( x ) / parseFloat( this.offsetWidth) ) * 100 );
    });
  },
  created() {
    eventBus.$on('isAllParagraphChecked',
        isChecked => {
          this.canBeSaved = isChecked
        }
    )
    eventBus.$on('changePlayerStatus', (status) => {
      this.playerStatus = status;
    })
  }
}
</script>
<style scoped lang="scss">
$purple: #8E8AD3;
$gray: #F8F8F8;
$main-gradient: linear-gradient(159.16deg, #917CE4 26.46%, rgba(63, 45, 137, 0) 116.55%);
$secondary-gradient: linear-gradient(159.16deg, #21A28E 26.46%, #2D622F 116.55%);
$shadow: 10px 10px 15px 0px #FFFFFF33 inset, 0px 5px 10px 0px #372E98A6;

.player-block{
  display: flex;
  justify-content: space-between;

  .player-block__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 20%;

    .player-block__outer-button {
      width: 37px;
      height: 37px;
      border-radius: 50%;
      margin: auto;
      background: $gray;
      box-shadow: -10px -10px 20px 0px #FFFFFF inset,
                  10px 10px 10px 0px #0000000D,
                  -10px -10px 15px 0px #FFFFFF,
                  10px 10px 10px 0px #0000000D inset;
      position: relative;

      &.player-block__outer-button--nav{
        width: 30px;
        height: 30px;
      }
      button {
        width: 21px;
        height: 21px;
        top: 50%;
        left: 50%;
        background: $main-gradient;
        transform: translate3d(-50%, -50%, 0);
        position: absolute;
        border-radius: 50%;
        border: none;
        box-shadow: $shadow;
        filter: drop-shadow(0px 5px 10px rgba(55, 46, 152, 0.65));
        padding: 0;

        &.player-block__play-button--add{
          background: $secondary-gradient;
        }

        &.player-block__play-button--big {
          width: 27px;
          height: 27px;
          padding: 0;
        }
      }
    }
  }
}

.unique-purple {
  color: $purple;
}
</style>